import React, { Fragment } from 'react';

import { Grid } from '@mui/material';
import useTransformStore from '../../useTransformStore';
import ChipInput from '../../../ChipInput/ChipInput';

function Join({ availablePlaceholders, onPlaceholderSelected, newList, index }) {
  return (
    <Fragment>
      <Grid item xs={12} className="item-label">
        Join all values and lists below into a new list.
      </Grid>
      <Grid item xs={12} className="input-list-transform">
        <ChipInput
          placeholders={availablePlaceholders}
          onPlaceholderSelected={onPlaceholderSelected}
          fullWidth
          onBeforeAdd={chip => {
            useTransformStore.getState().setComponent(chip, index, 'newList');
            return true;
          }}
          placeholder="Insert a list "
          inputValue={newList}
          onDelete={indexChip => useTransformStore.getState().deleteChip(indexChip, index, 'newList')}
          onFocus={() => useTransformStore.getState().setFocus(index, 'newList')}
        />
      </Grid>
    </Fragment>
  );
}

export default Join;
